export default {
  'administration.title': 'Administration',
  'administration.copyProcess': 'Copy Process',
  'administration.newProcess': 'New Process Name',
  'administration.copyProcess.description':
    'Copy process and all its configurations. It will also be copied, if necessary, the related entities (Forms, Fields, Formats, Related Entities,...)',
};
